module.exports = __webpack_public_path__ + "media/assets/consultation/platform_mobile-b8b180d1260820afc6d7a07d080b2cb0.svg";